import React, { Component } from "react";
import { Card, Container, CardDeck } from "react-bootstrap";
import tile1 from "../DoneImg/1.jpg";
import tile2 from "../DoneImg/2.jpg";
import tile3 from "../DoneImg/3.webp";
import tile4 from "../DoneImg/4.jpg";
import tile5 from "../DoneImg/5.jpg";
import tile6 from "../DoneImg/6.jpg";
import tile7 from "../DoneImg/7.jpg";
import tile8 from "../DoneImg/8.jpg";
import tile9 from "../DoneImg/9.webp";
import tile10 from "../DoneImg/10.jpg";
import tile11 from "../DoneImg/11.webp";
import tile12 from "../DoneImg/12.webp";
import tile13 from "../DoneImg/13.jpg";
import tile14 from "../DoneImg/14.jpg";
import tile15 from "../DoneImg/15.jpg";
export default class Gallery extends Component {
  render() {
    return (
      <>
        <Container>
          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile1} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile2} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile3} />
            </Card>
          </CardDeck>

          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile4} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile5} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile6} />
            </Card>
          </CardDeck>

          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile7} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile8} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile9} />
            </Card>
          </CardDeck>

          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile10} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile11} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile12} />
            </Card>
          </CardDeck>

          <CardDeck className="m-4">
            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile13} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile14} />
            </Card>

            <Card className="bg-secondary text-white" border="primary">
              <Card.Img variant="top" src={tile15} />
            </Card>
          </CardDeck>
        </Container>
      </>
    );
  }
}
